/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Constants } from '../../../Constants';
import { DocumentType } from '../../../models/DocumentType';
import { SecurityScheme } from '../../../models/common/SecurityScheme';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { RequiredPropertyValidationRule } from './RequiredPropertyValidationRule';
import { Document } from '../../../models/Document';

/**
 * Constructor.
 * 
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends RequiredPropertyValidationRule
 * @author eric.wittmann@gmail.com
 */
export class MissingApiKeySchemeParamLocationRule extends RequiredPropertyValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        if(node.ownerDocument().getDocumentType() === DocumentType.asyncapi2) {
            if(this.equals(node.type, "apiKey") || this.equals(node.type, "httpApiKey")) {
                this.requireProperty(node, Constants.PROP_IN, this.map.apply(this, ));
            }
        } else {
            this.requirePropertyWhen(node, Constants.PROP_IN, Constants.PROP_TYPE, "apiKey", this.map.apply(this, ));
        }
    }
}
MissingApiKeySchemeParamLocationRule["__class"] = "io.apicurio.datamodels.core.validation.rules.required.MissingApiKeySchemeParamLocationRule";
MissingApiKeySchemeParamLocationRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




